<template>
  <v-alert
    text
    color="primary"
  >
    <h3 class="text-h5">
      {{ $t('turismo.survey.title', locale) }}
    </h3>
    <div>
      {{ $t('turismo.survey.description', locale) }}
    </div>

    <v-divider
      class="my-4 info"
      style="opacity: 0.22"
    ></v-divider>

    <v-row
      align="center"
      no-gutters
    >
      <v-col>
        <v-btn
          color="primary"
          outlined
          @click="handleAddMenu"
        >
        {{ $t('turismo.survey.addQuestion', locale) }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>
<script>
export default {
  props: {
    locale: {
      type: String,
      default: null,
    },
    onAddMenu: {
      type: Function,
      required: true,
    },
  },
  methods: {
    handleAddMenu () {
      this.onAddMenu()
    },
  },
}
</script>

